import * as React from 'react';
export default function FooterRow(props) {
  return React.createElement("tr", Object.assign({}, props));
}